<div class="filter-inputs">
  <label>Academic Year</label>
     <div class="input-groups">
      <!-- <select class="form-select formMainSelectdiv">
        <option>{{currentAcademicYear?.description}}</option>
      </select> -->
       <select 
          class="form-select formMainSelectdiv" 
          [(ngModel)]="selectedAcademicYearId"
          (change)="onAcademicYearChange($event)"
          [class.non-current-year]="!isCurrentYear">
          <option value="" disabled>Select Academic Year</option>
          <option 
            *ngFor="let year of academicList" 
            [value]="getAcademicYearId(year)"
            [selected]="getAcademicYearId(year) === academicYearId">
            {{ year.description }}
            <!-- <ng-container *ngIf="year.isCurrentlyActive || year.setAsCurrentAcademicYear"> • Current</ng-container> -->
             <ng-container *ngIf="year.isCurrentlyActive || year.setAsCurrentAcademicYear"></ng-container>
          </option>
        </select>
    </div>
</div>

